var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1944 22.787L25.0065 29.7602H34.3505L23.0837 19.2806L26.1654 13.9141L18.1944 22.787ZM2.00195 7.91211L12.0177 18.3654L8.51118 22.8232L18.1055 15.0664L11.1122 7.91211H2.00195Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.8584 29.8453L10.8445 30L37.7737 4.019e-07L0.8584 29.8453Z",
    fill: "#EF8127"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6445 22.7809L25.1439 29.4348H33.5166L22.6679 19.3437L24.3372 16.4365L18.6445 22.7809Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77002 8.23145L12.4499 18.339L10.5633 20.7358L17.6224 15.0302L10.9749 8.23145H2.77002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.b3e1a0432dd569a9199c45216bd940fe.svg";
export { ForwardRef as ReactComponent };